import Request from '../../../../../src/core/gd/data/request'
import ApiDesktopNotifications from './desktop-notifications';

export default class ApiMyAccount {

    public DesktopNotifications     : ApiDesktopNotifications

    constructor() {
        this.DesktopNotifications = new ApiDesktopNotifications();
    }

    static twoFAStatus() {
        return new Request(this,'GET','my-account/2fa')
    }

    static twoFAReset(password:string) {
        return new Request(this,'PUT','my-account/2fa', {
            password    : password
        })
    }

    updateProfile(formData:any) {
        return new Request(this,'UPLOAD','my-account/profile',formData);
    }

    emailNotificationSettings(values:any) {
        return new Request(this,'PUT','my-account/notifications',values);
    }

    updateClientData(values:any) {
        return new Request(this,'PUT','my-account/client-data',values);
    }

    updateDateTime(values:any) {
        return new Request(this,'PUT','my-account/datetime',values);
    }

    myCompanies() {
        return new Request(this,'GET','my-account/my-companies');
    }

    deleteAccount() {
        return new Request(this,'DELETE','my-account/delete-account');
    }

    removeProfileIcon() {
        return new Request(this,'DELETE','my-account/profile/reset-icon');
    }

    googleAccounts() {
        return new Request(this, 'GET','my-account/integrations/google-accounts')
    }

    unlinkGoogleAccount(googleUserId:ID) {
        return new Request(this, 'DELETE','/my-account/integrations/google-account/{0}'.f(googleUserId))
    }

}
